import React, { FC } from 'react'
import { ShareholderValueProps } from './ShareholderValue.types'
import { sanitizeHTML } from '@ampdx/common-utils/src'
import { getValueListBgColor } from '@ampdx/component-library/src/utils'
import './ShareholderValue.scss'

export const ShareholderValue: FC<ShareholderValueProps> = props => {
  const {
    bgColor,
    heading,
    cashFlowPercentage,
    cashFlowContent,
    cashFlowList,
    capitalReturn,
    capitalReturnImage,
    capitalReturnImageAltText,
    leadingReturn,
    leadingReturnImage,
    leadingReturnImageAltText,
    capitalPosition,
    capitalPositionValue,
    linkText,
    linkDisclosure,
  } = props.content

  const scrollToSection = (path: string) => {
    const section = document.getElementById(path)
    section?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className={`ShareHolderValue--page ${getValueListBgColor(bgColor ?? '')}`}>
      <div className='u-sizeConstrained'>
        <div
          className='ShareHolderValue--heading u-paddingTop96 u-md-paddingTop48 u-sm-paddingTop48 u-paddingBottom64 u-md-paddingBottom32 u-sm-paddingBottom32 '
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(heading) }}></div>
        <div className='ShareHolderValue--cashFlowPercentageFlex u-flex u-md-flexCol u-sm-flexCol u-flexAlignItemsCenter u-paddingBottom40 u-md-paddingBottom20 u-sm-paddingBottom20'>
          <div className='u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsCenter'>
            <div
              className='ShareHolderValue--cashFlowPercentage'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(cashFlowPercentage) }}></div>
            <div
              className='ShareHolderValue--cashFlowContent'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(cashFlowContent) }}></div>
          </div>
          <div
            className='ShareHolderValue--cashFlowList u-padding20'
            dangerouslySetInnerHTML={{ __html: sanitizeHTML(cashFlowList) }}></div>
        </div>
        <hr className='ShareHolderValue--stroke' />
        <div
          className='ShareHolderValue--capitalReturn u-paddingTop40 u-md-paddingTop20 u-sm-paddingTop20'
          dangerouslySetInnerHTML={{ __html: sanitizeHTML(capitalReturn) }}></div>
        <div className='u-flex'>
          <img
            className='ShareHolderValue--capitalReturnImage'
            src={capitalReturnImage}
            alt={capitalReturnImageAltText}
          />
        </div>
        <hr className='ShareHolderValue--stroke' />
        <div className='u-flex u-sm-flexCol u-md-flexCol u-paddingTop32 u-md-paddingTop16 u-sm-paddingTop16'>
          <div className='u-flex u-flexCol'>
            <div
              className='ShareHolderValue--capitalReturn'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(leadingReturn) }}></div>
            <div className='u-flex'>
              <img
                className='ShareHolderValue--capitalReturnImage'
                src={leadingReturnImage}
                alt={leadingReturnImageAltText}
              />
            </div>
          </div>
          <hr className='ShareHolderValue--stroke ShareHolderValue--strokeHeight ' />
          <div className='u-flex u-flexCol u-flexJustifyCenter u-flexAlignItemsCenter u-md-paddingTop16 u-sm-paddingTop16 '>
            <div
              className='ShareHolderValue--cashFlowContent'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(capitalPosition) }}></div>
            <div
              className='Content ShareHolderValue--cashFlowPercentage'
              dangerouslySetInnerHTML={{ __html: sanitizeHTML(capitalPositionValue) }}></div>
          </div>
        </div>
        <div className='Disclaimer-text u-flex u-flexJustifyStart u-paddingVert48 u-md-paddingVert24 u-sm-paddingVert24'>
          <a
            className='ShareHolderValue--disclosureLink'
            href={'#' + linkDisclosure}
            onClick={e => {
              e.preventDefault()
              scrollToSection(linkDisclosure ?? '')
            }}>
            {linkText}
          </a>
        </div>
      </div>
    </section>
  )
}
